import api from 'services/api'
import { RequestBodyClientHierarchy } from './interfaces'

/**
 * @deprecated This component is deprecated and should not be used in new features
 * Use the new endpoint `getCustomers` from `services/customers`
 */
export const getClientHierarchy = async (query?: RequestBodyClientHierarchy) => {
  return api
    .get(`/cliente/v2/ListClienteHierarquia`, {
      params: query
    })
    .then((response) => response)
    .then((data) => data.data)
    .catch((error) => {
      console.error(error)
    })
}
